
import React from "react";
import styles from './footer.module.css';

function Footer(){
  return(
    <div className={styles.footer_div}>
      <h1 className={styles.footer}></h1>
    </div>
  )
}

export default Footer;



